import { render } from "./Archive_store.vue?vue&type=template&id=6014b216"
import script from "./Archive_store.vue?vue&type=script&lang=js"
export * from "./Archive_store.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__